export default {
  mynews_check_news: '0602Web-View message',
  mynews_show_news_list: '0601Web-Show message list',
  mynews_web_news: '06Web-Message',
  mynews_go_learn: 'Go to learn the course now?' ,
  mynews_go_Live: 'Go to the live now?'
}
